module.exports = __webpack_public_path__ + "img/icon-face-detection.14baaa53.svg";